import { render, staticRenderFns } from "./standard_data.vue?vue&type=template&id=33f4880d&"
import script from "./standard_data.vue?vue&type=script&lang=js&"
export * from "./standard_data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports